import { ArticleEditor } from './articleEditor';

export default ArticleEditor;
